var React = require('react');

function IcClose (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon/Outlined/Small Close"},React.createElement("path",{"id":"menu / close_small","d":"M21.744 7.99982L16 13.7438L10.256 7.99982L8 10.2558L13.744 15.9998L8 21.7438L10.256 23.9998L16 18.2558L21.744 23.9998L24 21.7438L18.256 15.9998L24 10.2558L21.744 7.99982Z","fill":"#262626"})));
}

IcClose.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = IcClose;

IcClose.default = IcClose;
